'use client'

import { useQuery } from '@tanstack/react-query'

import { QueryKey } from 'shared/api'

import { getCustomer } from '../api'

export const useQueryUser = (token: string) => {
  return useQuery({
    queryKey: [QueryKey.authUser, token],
    queryFn: async () => {
      if (!token) return null
      const response = await getCustomer({ token })

      return response.data.data
    },
    enabled: !!token,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
    staleTime: 1000 * 60 * 60 * 1 // 1 hour
  })
}
